import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=47b40dbe&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=47b40dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b40dbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b40dbe')) {
      api.createRecord('47b40dbe', component.options)
    } else {
      api.reload('47b40dbe', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=47b40dbe&scoped=true&", function () {
      api.rerender('47b40dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Ek66Brhf44vd/JS/comp/GuestBox.vue"
export default component.exports